import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { openContactForm } from "@/lib/contactForm";
import { Reveal, CountUp } from "@/pages/designPreview/previewMotion";
import { groupAuthorityFacts, loadPreviewCapabilities } from "@/pages/designPreview/previewData";
import { PreviewCta } from "@/pages/designPreview/PreviewBits";
import { OrbitDiagram, SceneIndex } from "@/pages/designPreview/PreviewVisuals";
import { themeOf } from "@/pages/designPreview/previewTheme";
import {
  BuildFlow,
  CapabilityTabs,
  ComparisonTable,
  FaqAccordion,
  ProcessFlow,
  StatStrip,
  TrustBadges,
} from "@/pages/designPreview/capabilitiesKit";
import "./capabilities.css";

export default function CapabilitiesPreview() {
  const [data, setData] = useState(null);
  const [active, setActive] = useState(null);
  useEffect(() => {
    loadPreviewCapabilities().then(setData).catch(() => setData(null));
  }, []);
  const layers = data?.layers || [];
  const comparison = data?.comparison || [];
  const grouped = groupAuthorityFacts(data?.authority?.facts || []);
  const trustFacts = [...(grouped.company || []), ...(grouped.credentials || [])];
  const metric = grouped.metric?.[0];
  const selected = layers.find((row) => row.id === active);
  const theme = selected ? themeOf(selected.id) : null;

  const stats = [
    { value: metric?.metric_value ? `${metric.metric_value}+` : "832+", label: metric?.public_label || "누적 프로젝트" },
    { value: `${layers.length || 7}`, label: "연결된 기술 레이어" },
    { value: "1", label: "설계부터 운영까지 하나의 팀" },
  ];

  return (
    <div>
      <section className="dp-scene">
        <div className="dp-gridbg" />
        <SceneIndex n={1} />
        <div className="dp-orbit-hero">
          <Reveal>
            <p className="dp-kicker">CAPABILITIES</p>
            <h1 className="dp-display">
              하나의 시스템으로
              <br />
              연결된 기술
            </h1>
            <p className="dp-lead">
              {data?.positioning?.entity ||
                "DSITESOLUTION은 웹사이트부터 맞춤형 웹개발, 관리자, SaaS, AI, 업무 자동화까지 한 흐름으로 구축합니다."}
            </p>
            <div
              className="dp-orbit-detail"
              style={theme ? { "--dp-node-hue": theme.hue, opacity: 1 } : { opacity: 0 }}
            >
              <p className="dp-kicker">{theme?.label}</p>
              <p>{selected?.summary}</p>
            </div>
            <PreviewCta onClick={openContactForm} />
            <StatStrip stats={stats} />
          </Reveal>
          <Reveal delay={120}>
            <OrbitDiagram layers={layers} active={active} onSelect={setActive} />
          </Reveal>
        </div>
      </section>

      <section className="dp-scene dp-scene--tight">
        <SceneIndex n={2} />
        <p className="dp-kicker">DEEP DIVE</p>
        <h2 className="dpcap-h2">레이어를 하나씩 살펴보세요</h2>
        <p className="dpcap-sub">탭을 눌러 각 기술 레이어가 실제로 무엇을 하는지 확인하세요.</p>
        <CapabilityTabs layers={layers} />
      </section>

      <section className="dp-scene dp-scene--tight">
        <SceneIndex n={3} />
        <p className="dp-kicker">PROCESS</p>
        <h2 className="dpcap-h2">구축 프로세스</h2>
        <p className="dpcap-sub">기획부터 검색 노출까지, 같은 팀이 하나의 흐름으로 진행합니다.</p>
        <ProcessFlow />
      </section>

      <section className="dp-scene dp-scene--tight">
        <SceneIndex n={4} />
        <p className="dp-kicker">THE STACK</p>
        <h2 className="dpcap-h2">하나의 시스템이 쌓이는 순서</h2>
        <BuildFlow layers={layers} metric={metric} />
      </section>

      <section className="dp-scene dp-scene--tight">
        <SceneIndex n={5} />
        <p className="dp-kicker">WHY DSITESOLUTION</p>
        <h2 className="dpcap-h2">일반 제작사와 무엇이 다른가</h2>
        <ComparisonTable rows={comparison} />
        <TrustBadges facts={trustFacts} />
      </section>

      <section className="dp-scene dp-scene--tight">
        <SceneIndex n={6} />
        <p className="dp-kicker">FAQ</p>
        <h2 className="dpcap-h2">자주 묻는 질문</h2>
        <FaqAccordion />
      </section>

      <section className="dp-scene dp-scene--tight">
        <SceneIndex n={7} />
        <div className="dp-showcase">
          <p className="dp-kicker">CONTINUE</p>
          <div>
            <Link to="/guides">Guide library</Link>
            <Link to="/portfolio/brand-web">Selected work</Link>
            <Link to="/design-preview/authority">Authority profile</Link>
          </div>
        </div>
        <PreviewCta onClick={openContactForm} />
      </section>
    </div>
  );
}
